import http from 'plugins/axios';

export default {
  getRobotList({page,size,pair}){
    return http.post({
        url:`/la/admin/robot/info/list?page=${page}&size=${size}&pair=${pair}`,
        // data,
        // dataType: 'form'
    })
  },
  delOneRobot(id){
    return http.post({
      url:`/la/admin/robot/info/del/${id}`
    })
  },
  addOneRobot(data){
    return http.post({
      url:'/la/admin/robot/info/add',
      data
    })
  },
updateOneRobotInfo(data){
  return http.post({
    url:'/la/admin/robot/info/update',
    data
  })
},
//获取镜像开关
getMirrorSwitch(pair){
  return http.get({
    url:`/la/admin/robot/mirror/switch?pair=${pair}`
  })
},
//修改镜像开关状态
updateMirrorSwitch({pair,parameter}){
  return http.post({
    url:`/la/admin/robot/mirror/update?pair=${pair}&parameter=${parameter}`
  })
},
//获取自成交开关
getSelfDealSwitch(pair){
  return http.get({
    url:`/la/admin/robot/mirrorBargain/info?pair=${pair}`
  })
},
//修改自成交开关状态
updateSelfDealSwitch({pair,parameter}){
  return http.post({
    url:`/la/admin/robot/mirrorBargain/updateSwitch?pair=${pair}&parameter=${parameter}`
  })
},
//修改自成交DelayInfo
updateSelfDealInfo({pair,parameter}){
  return http.post({
    url:`/la/admin/robot/mirrorBargain/updateDelay?pair=${pair}&parameter=${parameter}`
  })
},
 //获取fbsPairs
 getFbsPairs(){
  return http.get({
    url:'admin/symbol/fbsNames' //更改后的路径
    // url:' /la/admin/pair/list'
  })
 },
 //获取机器人pair开关和参数信息
 getSwitchObj(fbsPair){
  return http.post({
    url:`/la/admin/robot/pair/switch/obj?pair=${fbsPair}`,

  })
 },
 //修改机器人robot-pair开关信息
 updateRobotSwitch({pair,parameter}){
  return http.post({
    url:`/la/admin/robot/pair/switch/update?pair=${pair}&parameter=${parameter}`,

  })
 },
 //修改机器人robot-pair配置信息
 updateRobotPair({pair,parameter}){
  return http.post({
    url:`/la/admin/robot/pair/switch/updateDelay?pair=${pair}&parameter=${parameter}`,
  
  })
 },
//删除机器人开关
delOneRobotSwitch(pair){
  return http.post({
    url:`/la/admin/robot/pair/switch/delDelay?pair=${pair}`,
    
  })
 },
//  //删除一个机器人开关
//  delOneRobotSwitch(pair){
//   return http.post({
//     url:``
//   })
//  }
//添加机器人开关
addRobotSwitch({pair,delayName,parameter}){
  return http.post({
    url:`/la/admin/robot/pair/switch/addDelay?pair=${pair}&delayName=${delayName}&parameter=${parameter}`
  })
}

};
